import http from 'conversations-http/clients/http';
// Only prevent duplicate concurrent requests, no persistent caching
const pendingRequests = new Map();
const getRequestKey = ({
  threadId,
  includeDeletedHistory,
  historyLimit
}) => {
  return `${threadId}:${includeDeletedHistory}:${historyLimit}`;
};
export const fetchThreadListMemberDetails = async ({
  threadId,
  includeDeletedHistory = false,
  historyLimit = 30
}) => {
  const requestKey = getRequestKey({
    threadId,
    includeDeletedHistory,
    historyLimit
  });

  // Check if there's already a pending request
  const existingRequest = pendingRequests.get(requestKey);
  if (existingRequest) {
    return existingRequest;
  }
  const requestPromise = http.get(`messages/v2/threadlist/member/${threadId}/details`, {
    query: {
      expectedResponseType: 'WRAPPER_V2',
      includeDeletedHistory,
      historyLimit
    }
  });

  // Store pending request
  pendingRequests.set(requestKey, requestPromise);
  try {
    const response = await requestPromise;
    return response;
  } finally {
    pendingRequests.delete(requestKey);
  }
};